module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Map/Direction2-459a107807cc0df431706fcda7643387.svg";